import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function ServiceTabFive() {
    return (
        <Container>
            <Row style={{ justifyContent: 'center' }} >
                <Row className='mt-3'>
                    <Col className='service_des_title' > AMC & RESOURCE DEPLOYMENT </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <p className='service_des_p' >
                            We, at Royality Technologies, provide our customers with maintenance contracts, onsite support and round-the-year services of CCTV, biometrics devices, and other security products. We offer dedicated protection to your staff, property, visitors, etc. by providing services like- cleaning the lens of cameras and checking all the functions of it, checking and correcting the configuration of your devices, etc. We are equipped with advanced tools and experienced professional experts which help us meet our customers’ standards and understand their vision.
                        </p>
                        {/* <p className='service_des_p'>
                            We offer exclusive protection to your staff, property, visitors, and many more by cleaning the lens and checking all the functions of the CCTV cameras. We are equipped with advanced tools and professional experts who meet all your standard needs and tranquility to solve the complications related to your CCTV technical problems and many more.
                        </p> */}
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='service_des_title'> Lower The Maintenance Cost in Just a Call  </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='service_des_p' >
                        <p className='service_des_p'> No matter if the problem may be in your security system, our experts are ready to alleviate it in no time at an affordable price. You can enjoy our monthly/yearly maintenance service of your security installations. These maintenances help larger institutes better such as-</p>
                        <ul>
                            <li>Security At Your Schools/Universities</li>
                            <li> Security At Your Offices</li>
                            <li> Security At Hotels </li>
                            <li> Security At Your Industrial buildings</li>
                        </ul>
                        <p className='service_des_p'> If you face any problem related to your security systems, then submit your security issues with us, and we will save you money and time by giving you exceptional solutions. We are the best security service dealers in Hyderabad and CCTV camera dealers who care for their customers' security by offering you the best maintenance packages. </p>
                    </Col>
                </Row>
            </Row>
        </Container>
    )
}

export default ServiceTabFive